import { Bell, Plus, Search } from "lucide-react";
import { NAV_ITEMS } from "./homeData";

// Product window chrome — mirrors the real TRAIDE workspace (header + calm sidebar). Content panels plug into `children`.
export function Window({ active = "Home", crumb, children, className = "", testid, side = true, height }) {
  return (
    <div className={`hw ${className}`} data-testid={testid} style={height ? { height } : undefined}>
      <div className="hw-bar">
        <span className="hw-dots"><i /><i /><i /></span>
        <span className="truncate font-semibold text-[#0A0A0B]">{crumb || "Harbour City Plumbing"}</span>
        <span className="ml-auto hidden items-center gap-1.5 rounded-md border border-[#E4E4E7] bg-white px-2 py-1 text-[11px] text-[#A1A1AA] sm:flex"><Search size={11} /> Search customers, jobs, quotes… <kbd className="ml-1 rounded border border-[#E4E4E7] px-1 font-mono text-[9px]">⌘K</kbd></span>
        <span className="ml-2 hidden h-6 items-center gap-1 rounded-md bg-[#F59E0B] px-2 text-[11px] font-semibold text-[#0A0A0B] sm:inline-flex"><Plus size={11} strokeWidth={2.5} /> Create</span>
        <Bell size={13} className="ml-1 text-[#71717A]" />
        <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#0A0A0B] font-mono text-[9px] font-bold text-white">SM</span>
      </div>
      <div className="flex" style={height ? { height: `calc(${typeof height === "number" ? `${height}px` : height} - 40px)` } : undefined}>
        {side && (
          <aside className="hw-side">
            {NAV_ITEMS.map(([l, I]) => <div key={l} className={`hw-nav ${l === active ? "on" : ""}`}><I />{l}</div>)}
            <div className="mx-2 mt-3 border-t border-[#ECECEE] pt-2.5 text-[10.5px] leading-snug text-[#A1A1AA]">Sarah Mitchell<br />Owner</div>
          </aside>
        )}
        <div className="min-w-0 flex-1 overflow-hidden">{children}</div>
      </div>
    </div>
  );
}

export function Prio({ p }) { return <span className={`hw-chip ${p === "critical" ? "red" : "amber"}`}>{p}</span>; }
export function Metric({ l, v, s, tone }) {
  return <div className="hw-bar-seg min-w-0"><div className="hw-label">{l}</div><div className={`hw-num mt-1 text-[19px] leading-none ${tone === "neg" ? "text-red-700" : tone === "pos" ? "text-emerald-700" : ""}`}>{v}</div><div className="mt-1 truncate text-[10.5px] text-[#71717A]">{s}</div></div>;
}
export function Avatar({ n, className = "" }) { return <span className={`flex h-5 w-5 items-center justify-center rounded-full bg-[#0A0A0B] font-mono text-[8px] font-bold text-white ${className}`}>{n}</span>; }

// Phone frame — the real Staff app / Client portal run in a light screen inside a dark device.
export function Phone({ children, time = "7:02", className = "", testid, width = 300 }) {
  return (
    <div className={`mx-auto rounded-[30px] border border-white/15 bg-zinc-950 p-2.5 shadow-[0_40px_90px_-40px_rgba(0,0,0,.9)] ${className}`} style={{ width }} data-testid={testid}>
      <div className="overflow-hidden rounded-[22px] bg-white text-[#0A0A0B]">
        <div className="flex items-center justify-between px-4 pt-3 text-[11px] font-semibold"><span>{time}</span><span className="h-1.5 w-12 rounded-full bg-zinc-950" /><span>5G</span></div>
        {children}
      </div>
    </div>
  );
}
